import { SxProps, Theme } from '@mui/material';

export const getRetailListItemButtonStyles = (
  isActive: boolean,
  overridingStyles?: SxProps<Theme>
): SxProps<Theme> => {
  return {
    height: '48px',
    color: isActive ? 'nav.text' : 'nav.textMuted',
    background: (theme) => (isActive ? theme.vars.palette.nav?.activeLight : 'none'),
    borderRadius: 3,
    justifyContent: 'center',
    ...overridingStyles,
  };
};

export const getRetailListItemIconStyles = (isActive: boolean): SxProps<Theme> => ({
  color: isActive ? 'nav.text' : 'nav.textMuted',
  minWidth: 20,
});
